// extracted by mini-css-extract-plugin
export var text = "Text-module--text--oLf-Y";